<template style="height:100%">
  <v-form @submit.prevent="submit" class="form">
    <div class="d-flex flex-column align-center">
      <h1 class="header font-weight-bold">Doctor Next 2 Me</h1>
      <p>Σύνδεση</p>

      <v-text-field
        label="Email"
        color="rgb(0,170,221)"
        prepend-inner-icon="mdi-account-outline"
        v-model="email"
        :error-messages="emailErrors"
      ></v-text-field>
      <v-text-field
        label="Συνθηματικό"
        color="rgb(0,170,221)"
        prepend-inner-icon="mdi-lock-outline"
        v-model="password"
        type="password"
        :error-messages="passwordErrors"
      ></v-text-field>
      <p class="paragraph" @click="$router.push('/forgot-password')">Ξεχάσατε τον κωδικό σας;</p>

      <v-btn
        rounded
        depressed
        color="rgb(0,170,221)"
        class="white--text text-capitalize btn"
        width="200"
        height="40"
        type="submit"
        :loading="$store.state.loading"
      >
        <p class="mb-0">Σύνδεση</p>
      </v-btn>

      <p class="registerText">
        Δεν έχετε λογαριασμό;
        <span
          style="color: rgb(0,170,221); cursor: pointer;"
          @click="$router.push('/register')"
        >Εγγραφή</span>
      </p>
    </div>

    <!-- <v-snackbar color="rgb(0,170,221)" v-model="snackbar">Η σύνδεση θα είναι σύντομα διαθέσιμη</v-snackbar> -->
  </v-form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import * as firebase from "firebase";

const loginFail = function(){
  return !this.loginError
}
export default {
  mixins: [validationMixin],
  data() {
    return {
      email: "",
      password: "",
      loginError: false
      // snackbar: false
    };
  },
  methods: {
    submit() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const credentials = {
          username: this.email,
          password: this.password,
          application: "app_traveller"
        };

        this.$store
          .dispatch("login", credentials)
          .then(res => {
             firebase.analytics().logEvent('login_patient')
            console.log(res)
            if (res.user.userProfile.isVerified) {
              this.$router.push("/home");
            }else{
              this.$router.push('/register/verification')
            }
          })
          .catch(err => {
            this.loginError = true
            console.log(err);
          });
        // this.snackbar= true
      }
    }
  },
  validations: {
    email: {
      required,
      email,
      loginFail
    },
    password: {
      required,
      loginFail
    }
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.required) errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.email.email) errors.push("Πρέπει να είναι σωστό email");
      if (!this.$v.email.loginFail) errors.push('Λάθος email ή συνθηματικό')
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.required) errors.push("Υποχρεωτικό πεδίο");
      if (!this.$v.password.loginFail) errors.push('Λάθος email ή συνθηματικό')
      return errors;
    }
  },
  watch: {
    email(newValue, oldValue){
      if(oldValue !== newValue){
        this.loginError = false
      }
    },
    password(newValue,oldValue){
      if(oldValue !== newValue){
        this.loginError = false
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  margin-top: 60px;
}

.registerText {
  margin-top: 100px;
}

.paragraph {
  color: rgb(0, 170, 221);
  font-size: 13px;
  margin-top: 15px;
  cursor: pointer;
}

.btn {
  margin-top: 50px;
}
</style>